import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { useFormatPricePeriod } from "@hooks/useFormatPricePeriod";
import {
  PricePeriodType,
  type IAdditionalService,
  type IDetailedAdditionalService,
} from "@services/additional-services/types";
import { isNullOrUndefined } from "@utils/common";

interface IAdditionalServicePriceProps {
  service?: IDetailedAdditionalService | IAdditionalService;
}

export const AdditionalServicePrice: React.FC<IAdditionalServicePriceProps> = ({
  service,
}) => {
  const { t } = useTranslation();
  const formattedPrice = useFormatPricePeriod(
    service?.price ?? 0,
    PricePeriodType.MONTH,
  );

  const formattedInitialPrice = useFormatPricePeriod(
    !isNullOrUndefined(service?.initialPrice)
      ? (service?.initialPrice as unknown as number)
      : (service?.price ?? 0),
    PricePeriodType.MONTH,
  );

  const initialPriceText = service?.initialPrice
    ? formattedInitialPrice
    : undefined;

  const formattedFirstMonthPrice = useFormatPricePeriod(
    !isNullOrUndefined(service?.firstMonthPrice)
      ? (service?.firstMonthPrice as unknown as number)
      : (service?.price ?? 0),
    PricePeriodType.MONTH,
  );

  const firstMonthPriceText = service?.firstMonthPrice
    ? formattedFirstMonthPrice
    : undefined;

  return (
    <div className="lext-lg whitespace-nowrap leading-6">
      <div>
        <span className="text-sm leading-5 text-grey-dark">
          {t("additionalServices.price.validForOneMonth")}
        </span>
      </div>
      {firstMonthPriceText ? (
        <>
          <span className="font-semibold text-base-green">{`${firstMonthPriceText}, `}</span>
          <span className="text-base-green">
            {t("additionalServices.price.later") + " " + formattedPrice}
          </span>
        </>
      ) : (
        <>
          <span
            className={twMerge(
              "font-semibold",
              initialPriceText && "text-base-green",
            )}
          >
            {formattedPrice}
          </span>
          {initialPriceText && (
            <span className="line-through">{initialPriceText}</span>
          )}
        </>
      )}
    </div>
  );
};
